import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import {
  formatRentalPotential,
  formatRevenue,
} from '../InitialInformationStep';
import {
  CustomerType,
  PricingSheetRow,
} from '../../../../../shared/types';
import { getCustomerTypeLabel } from '../../../helpers/getCustomerTypeLabel';
import { RentalHistorySourceType } from '../../../../../shared/types/pricingSheets';
import { getRentalHistoryCustomerTypeLabel } from '../../../helpers/getRentalHistoryCustomerTypeLabel';
import { formatDateTolocaleDateString } from '../../../utils/formatDateTimes';
import { isRentalHistoryRow } from '../../../../../shared/helpers/isRentalHistoryRow';

type CustomerSummaryBoxProps = {
  customerName?: string;
  revenue?: number;
  potential?: any;
  industry?: string;
  customerType?: CustomerType;
  rentalHistoryCustomerId?: string;
  rentalHistoryCompanyId?: string;
  rentalHistoryStartDate?: Date;
  rentalHistoryEndDate?: Date;
  rentalHistorySourceType?: RentalHistorySourceType;
  rentalHistoryCompanyName?: string;
  rentalHistoryCustomerName?: string;
  pricingSheetRows?: PricingSheetRow[];
};

export const CustomerSummaryBox = ({
  customerName,
  revenue,
  potential,
  industry,
  customerType,
  rentalHistoryCustomerId,
  rentalHistoryCompanyId,
  rentalHistoryStartDate,
  rentalHistoryEndDate,
  rentalHistorySourceType,
  rentalHistoryCustomerName,
  rentalHistoryCompanyName,
  pricingSheetRows,
}: CustomerSummaryBoxProps) => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: '#e9edf1',
          padding: 4,
          borderRadius: 8,
          minWidth: '600px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" color="primary">
            Asiakkaan tiedot
          </Typography>
        </Box>
        <Table size="small" sx={{ ml: -2 }}>
          <TableBody>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', minWidth: 250 }}>
                Asiakkaan tyyppi
              </TableCell>
              <TableCell>
                {customerType
                  ? getCustomerTypeLabel(customerType)
                  : 'Asiakkaan tyyppiä ei ole määritelty'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>
                Asiakkaan nimi
              </TableCell>
              <TableCell>
                {customerName || 'Asiakasta ei valittuna!'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>
                Liikevaihto
              </TableCell>
              <TableCell>
                {revenue
                  ? formatRevenue(revenue)
                  : 'Liikevaihtoa ei valittuna!'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>
                Potentiaali
              </TableCell>
              <TableCell>
                {potential
                  ? formatRentalPotential(
                      potential.bottom,
                      potential.top,
                    )
                  : 'Vuokrapotentiaali ei valittuna!'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>
                Asiakkaan toimiala
              </TableCell>
              <TableCell>
                {industry || 'Segmenttiä ei valittuna!'}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>{' '}
      </Box>
      <Box
        sx={{
          backgroundColor: '#e9edf1',
          padding: 4,
          borderRadius: 8,
          minWidth: '600px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mt: 2,
          }}
        >
          <Typography variant="h6" color="primary">
            Vuokrahistorian tiedot
          </Typography>
        </Box>
        <Table size="small" sx={{ ml: -2 }}>
          <TableBody>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', minWidth: 250 }}>
                Asiakkaan tyyppi
              </TableCell>
              <TableCell>
                {rentalHistorySourceType
                  ? getRentalHistoryCustomerTypeLabel(
                      rentalHistorySourceType,
                    )
                  : 'Asiakkaan tyyppiä ei ole määritelty'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>
                Asiakkaan nimi
              </TableCell>
              <TableCell>
                {rentalHistorySourceType ===
                RentalHistorySourceType.Customer
                  ? rentalHistoryCustomerName ?? '-'
                  : rentalHistoryCompanyName ?? '-'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>
                Asiakkaan id
              </TableCell>
              <TableCell>
                {rentalHistorySourceType ===
                RentalHistorySourceType.Customer
                  ? rentalHistoryCustomerId ?? '-'
                  : rentalHistoryCompanyId ?? '-'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>
                Vuokrahistoria väliltä
              </TableCell>
              <TableCell>{`${rentalHistoryStartDate ? formatDateTolocaleDateString(rentalHistoryStartDate) : 'Ei määritelty'} - ${rentalHistoryEndDate ? formatDateTolocaleDateString(rentalHistoryEndDate) : 'Ei määritelty'}`}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>
                Vuokratuotteita hinnastossa
              </TableCell>
              <TableCell>
                {pricingSheetRows
                  ? pricingSheetRows.filter((row) =>
                      isRentalHistoryRow(row),
                    ).length
                  : 0}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </>
  );
};
